import React from 'react';

import { Divider, Paper, Stack, Typography } from '@mui/material';

import { DashboardOverviewBlockEmployeeUserStats } from 'src/components/dashboard/components/DashboardOverviewBlock/DashboardOverviewBlockEmployeeUserStats';
import {
  useOverviewCredentialedVerifiers,
  useOverviewDataPrivacyStates,
  useOverviewEmployeeStats,
  useOverviewLastMonthDataDisputes,
  useOverviewManualRequestsActivity,
  useOverviewRevenueShareAccounts,
  useOverviewTotalVerifications,
} from 'src/hooks/dashboard';
import { SxProp } from 'src/types/mui';

import { DashboardOverviewBlockDataDisputes } from './DashboardOverviewBlockDataDisputes';
import { DashboardOverviewBlockDataPrivacyStates } from './DashboardOverviewBlockDataPrivacyStates';
import { DashboardOverviewBlockManualRequestActivity } from './DashboardOverviewBlockManualRequestActivity';
import { DashboardOverviewBlockRevenueShareAccounts } from './DashboardOverviewBlockRevenueShareAccounts';
import { DashboardOverviewBlockTotalVerifications } from './DashboardOverviewBlockTotalVerifications';
import { DashboardOverviewBlockVerifiers } from './DashboardOverviewBlockVerifiers';

export const DashboardOverviewBlock: React.FC = () => {
  const { lastMonthDataDisputes, lastMonthDataDisputesLoading } =
    useOverviewLastMonthDataDisputes();

  const { dataPrivacyStates, lastUpdateDate, dataPrivacyStatesLoading } =
    useOverviewDataPrivacyStates();

  const { verifiers, verifiersLoading } = useOverviewCredentialedVerifiers();

  const { manualRequestActivity, manualRequestActivityLoading } =
    useOverviewManualRequestsActivity();

  const { totalVerifications, totalVerificationsLoading } = useOverviewTotalVerifications();

  const { revenueShareAccounts, revenueShareAccountsLoading } = useOverviewRevenueShareAccounts();

  const { employeeCounts, employeeStatsLoading } = useOverviewEmployeeStats();

  const loading =
    lastMonthDataDisputesLoading ||
    dataPrivacyStatesLoading ||
    verifiersLoading ||
    manualRequestActivityLoading ||
    totalVerificationsLoading ||
    employeeStatsLoading ||
    revenueShareAccountsLoading;

  return (
    <Paper sx={paperStyles} variant="outlined">
      <Stack spacing={2}>
        <Typography variant="subtitle1">Overview</Typography>
        <Divider />
        <Stack spacing={5}>
          <DashboardOverviewBlockDataDisputes
            lastMonthDataDisputes={lastMonthDataDisputes}
            loading={loading}
          />
          <DashboardOverviewBlockDataPrivacyStates
            states={dataPrivacyStates}
            lastUpdateDate={lastUpdateDate}
            loading={loading}
          />
          <DashboardOverviewBlockVerifiers verifiers={verifiers} loading={loading} />
          <DashboardOverviewBlockManualRequestActivity
            manualRequestsActivity={manualRequestActivity}
            loading={loading}
          />
          <DashboardOverviewBlockRevenueShareAccounts
            revenueShareAccounts={revenueShareAccounts}
            loading={loading}
          />
          <DashboardOverviewBlockTotalVerifications
            totalVerifications={totalVerifications}
            loading={loading}
          />
          <DashboardOverviewBlockEmployeeUserStats
            employeeCounts={employeeCounts}
            loading={loading}
          />
        </Stack>
      </Stack>
    </Paper>
  );
};

const paperStyles: SxProp = {
  py: 2.5,
  px: 3,
  borderRadius: 2,
  flexBasis: 0,
  flexGrow: 1,
  minWidth: 250,
};
